import React, { useEffect, useState } from 'react';
import "./Calendar.css";
import BodyExtraSmallMedium from '../designSystem/BodyExtraSmallMedium';
import BodySmallRegular from '../designSystem/BodySmallRegular';
import BodyMediumRegular from '../designSystem/BodyMediumRegular';
import chevron_leftIcon from "../../assets/images/chevron_leftCalendarIcon.svg"
import chevron_rightIcon from "../../assets/images/chevron_rightCalendarIcon.svg"
import { useDispatch, useSelector } from 'react-redux';
import { approveEmployeePlan, createBulkTasks, getEmployeePlan, getRejectPlanDetails, rejectEmployeePlan, updatePlanStatus } from '../../actions/userActions/EmployeePlanAction';
import BodySmallMedium from '../designSystem/BodySmallMedium';
import SubmitPlanModal from './SubmitPlanModal';
import CustomSelect from './CustomSelect';
import { getEmployeesByLevel } from '../../actions/userActions/employeeAction';
import myplanIcon from "../../assets/images/myplanIcon.svg";
import myplanIconBlue from "../../assets/images/myplanIconBlue.svg";
import crossIconRed from "../../assets/images/crossIconRed.svg";
import tickIcon from "../../assets/images/tickIcon.svg";
import listIcon from "../../assets/images/listIcon.svg";
import listIconBlue from "../../assets/images/listIconBlue.svg";
import calendarIconBlue from "../../assets/images/calendarIconBlue.svg";
import calendarIcon from "../../assets/images/calendarIcon.svg"
import ApprovePlanModal from './ApprovePlanModal';
import RejectPlanModal from './RejectPlanModal';
import CustomSubordinateSelect from './CustomSubordinateSelect';
import { getSubOrdinates } from '../../actions/userActions/tasks/taskAction';
import { IconButton } from '@mui/material';
import { NotepadText } from 'lucide-react';
import RejectionNotesDrawer from './RejectionNotesDrawer';
import SingleSelect from '../designSystem/SingleSelect';
import Heading6Regular from '../designSystem/Heading6Regular';
import CopyPlanButton from '../Copy Planner/CopyPlanButton';
import PastePlanButton from '../Copy Planner/PastePlanButton';
import { t } from '../../locales/translate';
import { toast } from 'react-toastify';


const NavigationHeader = ({ currentDate, selectedView, changeView, changeMonthOrWeek, formatMonth, planStatus, userId, planId, myPlan, setMyPlan, selectedEmployee, setSelectedEmployee,handleCopyClick,handlePasteClick, copyFeedback, copyMode,isPlannerOpen }) => {
    const DAYVIEW = "timeGridDay";
    const WEEKVIEW = "timeGridWeek";
    const MONTHVIEW = "dayGridMonth";
    const LISTVIEW = "list";
    const [currentMonth, setCurrentMonth] = useState(currentDate.getMonth() + 1);
    const [permissions, setPermissions] = useState(() => JSON.parse(localStorage.getItem("permissionsList") || "[]"));
    const [isSubmitPlanModalVisible, setIsSubmitPlanModalVisisble] = useState(false);
    const [isApprovePlanModalVisible, setIsApprovePlanModalVisisble] = useState(false);
    const [isRejectPlanModalVisible, setIsRejectPlanModalVisisble] = useState(false);
    const updatePlanStattuses = useSelector(state => state.employeePlan_reducer.updatePlanStatus);
    const updateEmployeePlanStatus = useSelector(state => state.employeePlan_reducer.updateEmployeePlan);
    const approvePlanStatus = useSelector(state => state.employeePlan_reducer.approveEmployeePlan);
    const rejectPlanStatus = useSelector(state => state.employeePlan_reducer.rejectEmployeePlan);
    const createBulkTasksStatus = useSelector(state => state.employeePlan_reducer.createBulkTasks);
    const subordinatesByLevel = useSelector((state) => state.employees_reducer.employeesByLevel);
    const subordinates = useSelector((state) => state.tasks_reducer.subOrdinates);
    const isSubordinatesLoading = useSelector((state) => state.tasks_reducer.isSubordinatesLoading);
    const deletePlanVisitsStatus = useSelector(state => state.employeePlan_reducer.deletePlanVisits);
    const [isRejectionDrawerOpen, setIsRejectionDrawerOpen] = useState(false);
    const [isToggleOn, setIsToggleOn] = useState(false);
    const dispatch = useDispatch();
    const { plannerSettings } = useSelector((state) => state.employees_reducer);
    const rejectPlanDetails = useSelector(state => state.employeePlan_reducer.rejectPlanDetails);   
    const employeePlan = useSelector(state => state.employeePlan_reducer.employeePlan);
    const hasPlanDetails = () => {
  if (
    employeePlan &&
    employeePlan.result &&
    employeePlan.result?.length > 0
  ) {
    return employeePlan.result.some(plan =>
      plan.employeePlanDates?.some(date => {
        if (date.onLeave === true) return true;
                if (date.planDetails && date.planDetails.length > 0) return true;
                if (date.visitProfiles && date.visitProfiles.length > 0) {
          return date.visitProfiles.some(vp => 
            vp.planDetails && vp.planDetails.length > 0
          );
        }
        
        return false;
      })
    );
  }
  return false;
};

        console.log("t function:", t);


    const hasCopiedPlans = localStorage.getItem('copiedPlanData');
    const now = new Date();
    const diff =
    (now.getFullYear() - currentDate.getFullYear()) * 12 +
    (now.getMonth() - currentDate.getMonth());

    const isWithinLastThreeMonths = diff >= 0 && diff <= 2;

   const isCurrentOrNextMonth = () => {
  const selectedDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
  const currentMonthStart = new Date(now.getFullYear(), now.getMonth(), 1);

  const nextMonthStart = new Date(now.getFullYear(), now.getMonth() + 1, 1);

  return (
    selectedDate.getTime() === currentMonthStart.getTime() ||
    selectedDate.getTime() === nextMonthStart.getTime()
  );
};

const isNextMonth = () => {
    const selectedDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const currentMonthStart = new Date(now.getFullYear(), now.getMonth(), 1);

    // Create next month's date from current month
    const nextMonth = new Date(currentMonthStart);
    nextMonth.setMonth(currentMonthStart.getMonth() + 1); // handles year rollover automatically

    return (
        selectedDate.getFullYear() === nextMonth.getFullYear() &&
        selectedDate.getMonth() === nextMonth.getMonth()
    );
};


useEffect(() => {
  const storedPermissions = JSON.parse(localStorage.getItem('permissionsList') || '[]');
  setPermissions(storedPermissions);
}, []);



 const isInRange = () => {
        const { startDate, endDate } = plannerSettings;
        if (!startDate || !endDate) {
            return false;
        }

        const today = new Date();
        const day = today.getDate();
        return day >= startDate && day <= endDate;
    };


const canShowSubmitButton = () => {
  const hasUnrestrictedAccess = permissions.includes("AllowUnrestrictedPlannerAccess");
  const isInWindow = isInRange();
  const isNext = isNextMonth();

  return hasUnrestrictedAccess || (isNext && isInWindow);
};


    useEffect(() => {
        if (userId && permissions.includes('CanViewEmployeeByLevel') && permissions.includes('CanViewSubordinatePlan')) {
        const searchQuery = "";
        const pageNumber = -1;
        const pageSize = 10;
        dispatch(getEmployeesByLevel(userId, searchQuery, pageNumber, pageSize));
        }
    }, [dispatch, userId]);
    useEffect(() => {
        if (isRejectionDrawerOpen && planId) {
            dispatch(getRejectPlanDetails(planId));
        }
    }, [isRejectionDrawerOpen, planId, dispatch]);

    const handleOpenRejectionDrawer = () => {
        setIsRejectionDrawerOpen(true);
    };

    const handleCloseRejectionDrawer = () => {
        setIsRejectionDrawerOpen(false);
    };

    useEffect(() => {
        const newMonth = currentDate.getMonth() + 1;
        if (currentMonth !== newMonth) {
            setCurrentMonth(newMonth);
        }
    }, [currentDate, currentMonth]);
    useEffect(() => {
        if (myPlan && userId && currentDate) {
            const employeeId = userId;
            const month = currentDate.getMonth() + 1;
            const year = currentDate.getFullYear();
            dispatch(getEmployeePlan(employeeId, month, year));
        } else if (!myPlan && currentDate && selectedEmployee) {
            const employeeId = selectedEmployee;
            const month = currentDate.getMonth() + 1;
            const year = currentDate.getFullYear();
            dispatch(getEmployeePlan(employeeId, month, year));
        }
    }, [currentMonth, myPlan, selectedEmployee]);
    useEffect(() => {
        if ((updatePlanStattuses && updatePlanStattuses !== "isLoading" && updatePlanStattuses === true && userId && currentDate) || (updateEmployeePlanStatus && updateEmployeePlanStatus !== "isLoading" && updateEmployeePlanStatus === true && userId && currentDate) || (rejectPlanStatus && rejectPlanStatus !== "isLoading" && rejectPlanStatus === true && userId && currentDate) || (deletePlanVisitsStatus && deletePlanVisitsStatus !== "isLoading" && deletePlanVisitsStatus === true && userId && currentDate)) {
            if (myPlan && userId && currentDate) {
                const employeeId = userId;
                const month = currentDate.getMonth() + 1;
                const year = currentDate.getFullYear();
                dispatch(getEmployeePlan(employeeId, month, year));
            } else if (!myPlan && currentDate && selectedEmployee) {
                const employeeId = selectedEmployee;
                const month = currentDate.getMonth() + 1;
                const year = currentDate.getFullYear();
                dispatch(getEmployeePlan(employeeId, month, year));
            }
            setIsSubmitPlanModalVisisble(false);
            setIsRejectPlanModalVisisble(false);
        }
    }, [currentMonth, updatePlanStattuses, updateEmployeePlanStatus, rejectPlanStatus, deletePlanVisitsStatus]);
    
    useEffect(() => {
        if (createBulkTasksStatus && createBulkTasksStatus !== "isLoading" && createBulkTasksStatus.status && userId && currentDate) {
            if (myPlan && userId && currentDate) {
                const employeeId = userId;
                const month = currentDate.getMonth() + 1;
                const year = currentDate.getFullYear();
                dispatch(getEmployeePlan(employeeId, month, year));
            } else if (!myPlan && currentDate && selectedEmployee) {
                const employeeId = selectedEmployee;
                const month = currentDate.getMonth() + 1;
                const year = currentDate.getFullYear();
                dispatch(getEmployeePlan(employeeId, month, year));
            }
            setIsApprovePlanModalVisisble(false);
            
            // Show success message with tasks created count
            if (createBulkTasksStatus.result && createBulkTasksStatus.result.length > 0) {
                const tasksCreated = createBulkTasksStatus.result[0].tasksCreated || 0;
                if (tasksCreated > 0) {
                    toast.success(`${tasksCreated} planned tasks have been created`, { autoClose: 3000 });
                } else {
                    toast.info('No tasks were created from the plan', { autoClose: 3000 });
                }
            }
        }
    }, [createBulkTasksStatus, userId, currentDate, myPlan, selectedEmployee]);
    const handleSubmitPlan = () => {

        setIsSubmitPlanModalVisisble(true);
    }

    const handleSubmitClick =async () => {
        if (planId) {
            await dispatch(updatePlanStatus(planId));
        }
    }
    
    const handleApproveClick = async () => {
        if (planId && planStatus === 2 && userId) {
            const statusId = 3;
            
            // First approve the plan
            const approvalSuccess = await dispatch(approveEmployeePlan(planId, statusId, userId));
            
            // Only proceed to create bulk tasks if approval succeeded
            if (!approvalSuccess) return;

            // Get the employee plan details for the approved plan
            if (employeePlan && employeePlan.result && employeePlan.result.length > 0) {
                const planToApprove = employeePlan.result.find(plan => plan.id === planId);
                
                if (planToApprove) {
                    const targetEmployeeId = planToApprove.employeeId;
                    const month = currentDate.getMonth() + 1; // getMonth() returns 0-11
                    const year = currentDate.getFullYear();

                    // Check if any date has visit profile plan details with time slots (nested in visitProfiles[].planDetails)
                    const hasVisitProfilePlanDetails = planToApprove.employeePlanDates &&
                        planToApprove.employeePlanDates.some(date =>
                            date.visitProfiles && date.visitProfiles.length > 0 &&
                            date.visitProfiles.some(vp =>
                                vp.planDetails && vp.planDetails.some(d => d.startTime)
                            )
                        );

                    const isCityOnlyPlan = !hasVisitProfilePlanDetails &&
                        planToApprove.employeePlanDates &&
                        planToApprove.employeePlanDates.length > 0 &&
                        planToApprove.employeePlanDates.every(date =>
                            !date.planDetails || date.planDetails.length === 0 ||
                            date.planDetails.every(d => (d.cityId || d.headOffice) && !d.startTime)
                        );

                    // Skip bulk tasks creation for city-only plans (no time slots)
                    if (!isCityOnlyPlan) {
                        await dispatch(createBulkTasks(targetEmployeeId, month, year));
                    } else {
                        // For city-only plans, close the modal manually since createBulkTasks won't be called
                        setIsApprovePlanModalVisisble(false);
                        if (myPlan) {
                            dispatch(getEmployeePlan(userId, currentDate.getMonth() + 1, currentDate.getFullYear()));
                        } else if (selectedEmployee) {
                            dispatch(getEmployeePlan(selectedEmployee, currentDate.getMonth() + 1, currentDate.getFullYear()));
                        }
                    }
                }
            }
        }
    }
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const handleRejectClick = async () => {
    if (!message.trim()) {
        setError("Message is required");
        return;
    }
    if (planId && planStatus === 2 && userId) {
        const statusId = 4;
        await dispatch(rejectEmployeePlan(planId, statusId, userId, message));
        setMessage("");
        setError("");
    }
};
    const getStatusClass = (status) => {
        switch (status) {
            case 1:
                return "draft-status";
            case 2:
                return "pending-status";
            case 3:
                return "approved-status";
            case 4:
                return "rejected-status";
            default:
                return "default-status";
        }
    };
    const onSubmitPlanModalClose = () => {
        setIsSubmitPlanModalVisisble(false);
    };
    const onApprovePlanModalClose = () => {
        setIsApprovePlanModalVisisble(false);
    };
    const onRejectPlanModalClose = () => {
        setIsRejectPlanModalVisisble(false);
    };
    const handleEmployeeChange = (event) => {
        const selectedEmployeeId = event.value;
        setSelectedEmployee(selectedEmployeeId);
        setMyPlan(false);
    };
    const handleMyPlan = () => {
        setMyPlan(true);
        setSelectedEmployee(null);
    };
    const handleApprovePlan = () => {
        setIsApprovePlanModalVisisble(true);
    };
    const handleRejectPlan = () => {
        setIsRejectPlanModalVisisble(true);
    };
    const getOptions = () => {
        const sortSubordinates = (subordinates) =>
            [...subordinates].sort((a, b) => {
                const firstNameComparison = a.firstName.localeCompare(b.firstName);
                if (firstNameComparison !== 0) {
                    return firstNameComparison;
                }
                return a.lastName.localeCompare(b.lastName);
            });

        if (
            permissions &&
            permissions.includes('CanViewEmployeeByLevel') &&
            permissions.includes('CanViewSubordinatePlan')
        ) {
            return (
                subordinatesByLevel &&
                subordinatesByLevel !== "isLoading" &&
                subordinatesByLevel.length !== 0 &&
                sortSubordinates(subordinatesByLevel).map((subordinate) => ({
                    value: subordinate.id,
                    labelWithDesigation: (
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: "5px", alignItems: "center" }}>
                            <span>{`${subordinate.firstName} ${subordinate.lastName}`}</span>
                            <span style={{ color: "#637381", fontSize: "12px" }}>{subordinate.designationShortName}</span>
                        </div>
                    ),
                    label: <span>{`${subordinate.firstName} ${subordinate.lastName}`}</span>,
                }))
            );
        } else if (
            permissions &&
            !permissions.includes('CanViewEmployeeByLevel') &&
            permissions.includes('CanViewSubordinatePlan')
        ) {
            return (
                subordinates &&
                subordinates !== "isLoading" &&
                subordinates.length !== 0 &&
                sortSubordinates(subordinates).map((subordinate) => ({
                    value: subordinate.id,
                    labelWithDesigation: (
                        <div style={{ display: 'flex', justifyContent: 'space-between', padding: "5px", alignItems: "center" }}>
                            <span>{`${subordinate.firstName} ${subordinate.lastName}`}</span>
                            <span style={{ color: "#637381", fontSize: "12px" }}>{subordinate.designationShortName}</span>
                        </div>
                    ),
                    label: <span>{`${subordinate.firstName} ${subordinate.lastName}`}</span>,
                }))
            );
        }
    };
    const getSubordinatesOptions = () => {
        if (
            subordinates &&
            subordinates !== "isLoading" &&
            subordinates.length > 0
        ) {
            return subordinates?.map(employee => ({
                value: employee.id,
                label: `${employee.firstName} ${employee.lastName}`,
                subtext:employee.designationName
            }));
        }
        return [];
    };
        const handleToggleChange = (isOn, currentValue) => {
        setIsToggleOn(isOn);

        if (isOn) {
            const searchQuery = "";
            const pageNumber = -1;
            const pageSize = 10;
              dispatch(getSubOrdinates(userId,pageNumber,pageSize,searchQuery));
        } else {
              const searchQuery = "";
            const pageNumber = -1;
            const pageSize = 10;
            dispatch(getEmployeesByLevel(userId, searchQuery, pageNumber, pageSize));
        }
    };
    const getEmployeesByLevelOptions = () => {
        if (
            subordinatesByLevel &&
            subordinatesByLevel !== "isLoading" &&
            subordinatesByLevel.length > 0
        ) {
            return subordinatesByLevel?.map(employee => ({
                value: employee.id,
                label: `${employee.firstName} ${employee.lastName}`,
                subtext:employee.designationName
            }));
        }
        return [];
    };
    return (
        <>
            <div className="calendar-header">
                <div style={{ marginBottom: canShowSubmitButton ? "40px" : "" }}
 className={`navigation-container ${hasCopiedPlans ? "paste-button-navigation-container" : ""} `}>
                    <div className="button-container">
                        <button
                            onClick={() => changeView(MONTHVIEW)}
                            className={`custom-button ${selectedView === MONTHVIEW ? "active" : ""}`}
                        >
                            <BodySmallRegular
                                text={t("month")}
                                color={selectedView === MONTHVIEW ? "#006CFA" : "#384153"}
                            />
                        </button>
                        <button
                            onClick={() => changeView(WEEKVIEW)}
                            className={`custom-button ${selectedView === WEEKVIEW ? "active" : ""}`}
                        >
                            <BodySmallRegular
                                text={t("week")}
                                color={selectedView === WEEKVIEW ? "#006CFA" : "#384153"}
                            />
                        </button>
                        <button
                            onClick={() => changeView(DAYVIEW)}
                            className={`custom-button ${selectedView === DAYVIEW ? "active" : ""}`}
                        >
                            <BodySmallRegular
                                text={t("day")}
                                color={selectedView === DAYVIEW ? "#006CFA" : "#384153"}
                            />
                        </button>
                    </div>
                    <div className='calendar-list-button-container'>
                        <button
                            onClick={() => changeView(MONTHVIEW)}
                            className={`custom-button-icon ${(selectedView === MONTHVIEW || selectedView === WEEKVIEW || selectedView === DAYVIEW) ? "active" : ""}`}
                        >
                            <img src={selectedView === LISTVIEW ? calendarIcon : calendarIconBlue} />
                        </button>
                        <button
                            onClick={() => changeView(LISTVIEW)}
                            className={`custom-button-icon ${selectedView === LISTVIEW ? "active" : ""}`}
                        >
                            <img src={selectedView === LISTVIEW ? listIconBlue : listIcon} />
                        </button>

                    </div>

                    <div className="month-container">
                        <img
                            src={chevron_leftIcon}
                            alt="Previous"
                            className="icon"
                            onClick={() => changeMonthOrWeek(-1)}
                        />
                        <img
                            src={chevron_rightIcon}
                            alt="Next"
                            className="icon"
                            onClick={() => changeMonthOrWeek(1)}
                        />
                        <BodyMediumRegular color="#1E293B" text={formatMonth()} />
                    </div>
                    {((myPlan && permissions.includes('CanAddPlan')) || (!myPlan && planStatus !== 1)) && (
                        <div className={`draft ${getStatusClass(planStatus)}`}>
                            <BodySmallMedium text={planStatus === 1 ? "Draft" : planStatus === 2 ? "Pending Approval" : planStatus === 3 ? "Approved" : planStatus === 4 ? "Needs Revision" : "Draft"} color={planStatus === 1 ? "#777777" : planStatus === 2 ? "#D97706" : planStatus === 4 ? "#E10E0E" : planStatus === 3 ? "#1A8245" : "#777777"} />
                        </div>
                    )}
                    {planStatus === 3 && isWithinLastThreeMonths && selectedView === MONTHVIEW &&(
                        <div>
                            <CopyPlanButton onClickHandler={handleCopyClick} copyFeedback={copyFeedback} copyMode={copyMode}/>
                            </div>
                    )}
                    {myPlan && planStatus === 1 && hasCopiedPlans && isCurrentOrNextMonth() && selectedView === MONTHVIEW &&(
                        <div>
                            <PastePlanButton onClick={handlePasteClick}/>
                            </div>
                    )}
                    {permissions && permissions.includes('CanViewPlan') && planStatus === 4 && (
                        <>
                            <div className="notes-button" onClick={handleOpenRejectionDrawer}>
                                <NotepadText size={16} />
                            </div>
                            <RejectionNotesDrawer
                                isOpen={isRejectionDrawerOpen}
                                onClose={handleCloseRejectionDrawer}
                                rejectPlanDetails={rejectPlanDetails}
                            />
                        </>
                    )}
                </div>
                <div className='otherbutton-container'>
                    <div className='myplan-employeeselect-container'>
                        {permissions?.includes('CanViewSubordinatePlan') && (
                            <>
                                {permissions?.includes('CanAddPlan') && (
                                    <button className={`my-plan-button ${myPlan ? 'my-plan-button-active' : ''}`} onClick={handleMyPlan}>
                                        <img src={myPlan ? myplanIconBlue : myplanIcon} />
                                        <BodySmallRegular text={t("myPlan")} color={myPlan ? "#006CFA" : "#637381"} />
                                    </button>
                                )}
                                <div className='employee-select'>
                                    <SingleSelect
                                        isSearchable
                                        onChange={handleEmployeeChange}
                                        value={selectedEmployee}
                                        placeholder={t("selectEmployee")}
                                        options={!isToggleOn ?
                                            (subordinatesByLevel &&
                                                subordinatesByLevel !== "isLoading" &&
                                                subordinatesByLevel.length > 0 ?
                                                getEmployeesByLevelOptions() : [])
                                            :
                                            (subordinates &&
                                                subordinates !== "isLoading" &&
                                                subordinates.length > 0 ?
                                                getSubordinatesOptions() : [])
                                        }
                                        isLoading={isToggleOn && isSubordinatesLoading}
                                        showToggle={true}
                                        toggleLabel="All Subordinates"
                                        isToggleOn={isToggleOn} 
                                        onToggleChange={handleToggleChange}
                                    />
                                </div>
                            </>
                        )}
                    </div>

                    {!myPlan && planStatus === 2 && (
                        <>
                            {permissions.includes('CanRejectPlan') && (
                                <button className='reject-button' onClick={handleRejectPlan}>
                                    <img src={crossIconRed} />
                                    <BodyExtraSmallMedium text={t("rejected")} color='#F23030' />
                                </button>
                            )}
                            {permissions.includes('CanApprovePlan') && (
                                <button className='approve-button' onClick={handleApprovePlan}>
                                    <img src={tickIcon} />
                                    <BodyExtraSmallMedium text={t("approve")} color='#FFFFFF' />
                                </button>
                            )}
                        </>
                    )}
                    

                   {(planStatus === 1 || planStatus === 4) &&
  myPlan &&
  permissions.includes("CanAddPlan") && (
    <>
      {canShowSubmitButton() ? (
        <div
          className="submit-plan-wrapper"
          title={!hasPlanDetails() ? "No plan added" : ""}
          style={{ marginTop: "8px" }}
        >
          <button
            className="submit-plan"
            onClick={handleSubmitPlan}
            disabled={!hasPlanDetails()}
            style={{
              cursor: !hasPlanDetails() ? "not-allowed" : "pointer",
              opacity: !hasPlanDetails() ? 0.6 : 1,
            }}
          >
            <Heading6Regular color="#FFFFFF" text={t("submitPlan")} />
          </button>
        </div>
      ) : (
        // Show warning banner only if it's next month and user doesn't have unrestricted access
         isNextMonth() && !permissions.includes("AllowUnrestrictedPlannerAccess") && plannerSettings.startDate && plannerSettings.endDate && (
                                <div
                                    style={{
                                    display: "flex",
                                    position: "absolute",
                                    left: "60px",
                                    top: "100px",
                                    alignItems: "center",
                                    backgroundColor: "#FFF8E1",
                                    border: "1px solid #FFECB3",
                                    borderRadius: "6px",
                                    padding: "8px 12px",
                                    marginTop: "8px",
                                    fontFamily: "Poppins",
                                    fontWeight: 500,
                                    fontSize: "14px",
                                    lineHeight: "22px",
                                    color: "#795548",
                                    }}
                                >
                                    <span style={{ marginRight: "6px", color: "#FF9800" }}>⚠️</span>
                                    {`You can update your plan between the ${plannerSettings.startDate}th and ${plannerSettings.endDate}th of every month`}
          </div>
        )
      )}
    </>
)}


                </div>
            </div>
            <SubmitPlanModal isVisible={isSubmitPlanModalVisible} onClose={onSubmitPlanModalClose} onSubmitClick={handleSubmitClick} hideTasksMessage={permissions && permissions.includes('CanAddPlannerCity') && !permissions.includes('CanAddPlannerTime')} />            <ApprovePlanModal isLoading={approvePlanStatus === "isLoading" || createBulkTasksStatus === "isLoading"} isVisible={isApprovePlanModalVisible} onClose={onApprovePlanModalClose} onApproveClick={handleApproveClick} hideTasksMessage={(() => { if (!employeePlan || !employeePlan.result) return false; const plan = employeePlan.result.find(p => p.id === planId); if (!plan || !plan.employeePlanDates) return false; const hasVisitProfileTimedDetails = plan.employeePlanDates.some(date => date.visitProfiles && date.visitProfiles.length > 0 && date.visitProfiles.some(vp => vp.planDetails && vp.planDetails.some(d => d.startTime))); if (hasVisitProfileTimedDetails) return false; return plan.employeePlanDates.every(date => (!date.planDetails || date.planDetails.length === 0 || date.planDetails.every(d => (d.cityId || d.headOffice) && !d.startTime))); })()}  />
            <RejectPlanModal
                isVisible={isRejectPlanModalVisible}
                onClose={onRejectPlanModalClose}
                onRejectClick={handleRejectClick}
                isLoading={rejectPlanStatus === "isLoading"}
                message={message}
                setMessage={setMessage}
                error={error}
            />
        </>
    );
};

// Add CSS keyframes for spinner animation
const styleSheet = document.styleSheets[0];
const keyframes = `
@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
`;
if (!document.querySelector('style[data-spinner-animation]')) {
    const style = document.createElement('style');
    style.setAttribute('data-spinner-animation', 'true');
    style.innerHTML = keyframes;
    document.head.appendChild(style);
}

export default NavigationHeader;